import AppInitializer from '@/components/AppInitializer.tsx';
import ScrollToBottom from '@/components/scrollToBottom/ScrollToBottom.tsx';
import { createEmotionCache } from '@/config/emotionCache.ts';
import { NavigationController } from '@/controller/Navigation.controller.tsx';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import Conflict409View from '@/views/409/Conflict409.view.tsx';
import AdminView from '@/views/admin/Admin.view.tsx';
import ErrorsView from '@/views/errors/ErrorsView.tsx';
import 'boosted/dist/js/boosted.bundle.min.js';
import InactiveView from '@/views/inactive/InactiveView.tsx';
import { LoginView } from '@/views/login/Login.view.tsx';

import './scss/styles.scss';
import './App.css';

import ProcessView from '@/views/process/Process.view.tsx';
import ServiceUnavailableView from '@/views/serviceUnavailable/ServiceUnavailable.view.tsx';
import WelcomeView from '@/views/welcome/Welcome.view.tsx';
import WelcomePage from '@/views/welcome/pages/Welcome.page.tsx';
import { CacheProvider } from '@emotion/react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';

import Layout from './components/layout/Layout.tsx';
import { AudioSettingsProvider } from './utils/providers/audioSettingsContext/AudioSettingsProvider.tsx';
import { LayoutProvider } from './utils/providers/layoutContext/LayoutProvider.tsx';

function AppRoutes() {
  const location = useLocation();
  const isServiceUnavailablePage = location.pathname === RoutesEnum.SERVICE_UNAVAILABLE;

  if (isServiceUnavailablePage) {
    return <ServiceUnavailableView />;
  }

  return (
    <AppInitializer>
      <NavigationController>
        <Routes>
          <Route element={<WelcomeView />} path={RoutesEnum.WELCOME} />
          <Route element={<LoginView />} path={RoutesEnum.LOGIN} />
          <Route element={<ProcessView />} path={RoutesEnum.QUIZ} />
          <Route element={<AdminView />} path={RoutesEnum.ADMIN} />
          <Route element={<WelcomePage />} path={RoutesEnum.ADMIN_LOGIN} />
          <Route element={<ErrorsView />} path={RoutesEnum.ERROR} />
          <Route element={<InactiveView />} path={RoutesEnum.INACTIVE} />
          <Route element={<Conflict409View />} path={RoutesEnum.CONFLICT_409} />
          <Route element={<ServiceUnavailableView />} path={RoutesEnum.SERVICE_UNAVAILABLE} />
          <Route element={<Navigate to={RoutesEnum.ROOT} />} path="*" />
        </Routes>
      </NavigationController>
    </AppInitializer>
  );
}

const nonce = document.querySelector("meta[property='csp-nonce']")?.getAttribute('content') ?? '';

const cache = createEmotionCache(nonce);

function App() {
  return (
    <>
      <Toaster />
      <CacheProvider value={cache}>
        <AudioSettingsProvider>
          <LayoutProvider>
            <Router>
              <Layout>
                <AppRoutes />
              </Layout>
              <ScrollToBottom />
            </Router>
          </LayoutProvider>
        </AudioSettingsProvider>
      </CacheProvider>
    </>
  );
}

export default App;
